import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { TargetingCondition } from '../../types';

interface TargetingConditionChipProps extends Omit<ChipProps, 'sx'> {
  condition: TargetingCondition;
  sx?: ChipProps['sx'];
}

/**
 * A reusable chip component for displaying targeting conditions with proper color contrast.
 * Handles special cases for light colors (YELLOW, LIME) to ensure text readability.
 */
const TargetingConditionChip: React.FC<TargetingConditionChipProps> = ({
  condition,
  sx = {},
  ...chipProps
}) => {
  const chipStyles = {
    backgroundColor: condition.tag_color.toLowerCase(),
    color: condition.tag_color === 'YELLOW' || condition.tag_color === 'LIME' ? 'black' : 'white',
    ...sx,
  };

  return <Chip label={condition.name} sx={chipStyles} {...chipProps} />;
};

export default TargetingConditionChip;
